// import { useState } from "react";
// import { toast } from "react-toastify";
// import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// import { useGetGallery, useDeleteImage } from "../../store/api/GalleryApi";

// const ITEMS_PER_PAGE = 12; // how many images per page

// function Gallery({ onEdit }) {
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);

//   const queryClient = useQueryClient();
//   const deleteImage = useDeleteImage();
//   const getGallery = useGetGallery();

//   const {
//     data: Data,
//     isLoading,
//     error,
//   } = useQuery({
//     queryKey: ["gallery"],
//     queryFn: getGallery,
//   });

//   const mutation = useMutation({
//     mutationFn: (filename) => deleteImage(filename),
//     onSuccess: () => {
//       setLoading(false);
//       toast.success("Successfully Deleted!");
//       queryClient.invalidateQueries(["gallery"]);
//     },
//     onError: (error) => {
//       setLoading(false);
//       toast.error(error?.message || "Something went wrong!");
//       console.error("Delete Error:", error);
//     },
//   });

//   const onDelete = (imageUrl) => {
//     const filename = imageUrl.split("/").pop();

//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this image?"
//     );
//     if (!confirmDelete) return;

//     setLoading(true);

//     try {
//       setTimeout(() => {
//         if (!filename) {
//           setLoading(false);
//           return alert("Filename not found!");
//         }
//         mutation.mutate(filename);
//       }, 1000);
//     } catch (err) {
//       setLoading(false);
//       toast.error(err?.message || "Unexpected error");
//     }
//   };

//   if (isLoading) {
//     return <div className="my-5 text-center fw-bold">Loading...</div>;
//   }

//   if (error) {
//     return (
//       <div className="my-5 text-center fw-bold text-danger">
//         Error: {error.message}
//       </div>
//     );
//   }

//   const allImages = Data?.images?.reverse() || [];

//   // Calculate pagination values
//   const totalItems = allImages.length;
//   const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
//   const currentPage = Math.min(page, totalPages) || 1;

//   // Calculate slice indexes
//   const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
//   const endIndex = startIndex + ITEMS_PER_PAGE;

//   // Slice images to display on current page
//   const paginatedImages = allImages.slice(startIndex, endIndex);

//   // Pagination controls
//   const canPrev = currentPage > 1;
//   const canNext = currentPage < totalPages;

//   return (
//     <div className="container-fluid my-5">
//       <div className="row g-3">
//         {paginatedImages.map((imgUrl, index) => (
//           <div
//             className="col-4 col-sm-2 col-md-2 mb-3"
//             key={startIndex + index}
//           >
//             <div className="card shadow-sm position-relative">
//               <img
//                 src={imgUrl.url}
//                 alt={`Uploaded ${startIndex + index}`}
//                 className="card-img-top"
//                 style={{ height: "180px", objectFit: "cover" }}
//               />
//               {/* <div className="card-body p-2">
//                 <button
//                   className="btn btn-sm btn-primary me-2"
//                   onClick={() => {
//                     navigator.clipboard.writeText(imgUrl);
//                     alert("Image URL copied to clipboard!");
//                   }}
//                   type="button"
//                 >
//                   Copy URL
//                 </button>
//                 <button
//                   className="btn btn-sm btn-danger"
//                   onClick={() => onDelete(imgUrl)}
//                   disabled={loading}
//                   type="button"
//                 >
//                   {loading ? "Deleting..." : "Delete"}
//                 </button>
//               </div> */}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Pagination controls */}
//       <div className="d-flex justify-content-center gap-3 my-4">
//         <button
//           className="btn btn-outline-primary"
//           onClick={() => setPage((old) => Math.max(old - 1, 1))}
//           disabled={!canPrev}
//         >
//           Prev
//         </button>

//         <span className="align-self-center">
//           Page {currentPage} of {totalPages}
//         </span>

//         <button
//           className="btn btn-outline-primary"
//           onClick={() => setPage((old) => Math.min(old + 1, totalPages))}
//           disabled={!canNext}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Gallery;
import { useState } from "react";
import { toast } from "react-toastify";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useGetGallery, useDeleteImage } from "../../store/api/GalleryApi";

const ITEMS_PER_PAGE = 30;

function Gallery({ onEdit }) {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(null);

  const queryClient = useQueryClient();
  const deleteImage = useDeleteImage();
  const getGallery = useGetGallery();

  const {
    data: Data,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["gallery"],
    queryFn: getGallery,
  });

  const mutation = useMutation({
    mutationFn: (filename) => deleteImage(filename),
    onSuccess: () => {
      setLoading(false);
      toast.success("Successfully Deleted!");
      queryClient.invalidateQueries(["gallery"]);
    },
    onError: (error) => {
      setLoading(false);
      toast.error(error?.message || "Something went wrong!");
      console.error("Delete Error:", error);
    },
  });

  const onDelete = (imageUrl) => {
    const filename = imageUrl.split("/").pop();

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this image?"
    );
    if (!confirmDelete) return;

    setLoading(true);

    try {
      setTimeout(() => {
        if (!filename) {
          setLoading(false);
          return alert("Filename not found!");
        }
        mutation.mutate(filename);
      }, 1000);
    } catch (err) {
      setLoading(false);
      toast.error(err?.message || "Unexpected error");
    }
  };

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("URL copied to clipboard!");
  };

  if (isLoading) {
    return (
      <div className="modern-gallery-container">
        <style>{`
          .modern-gallery-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            padding: 2rem;
          }

          .loading-gallery {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
          }

          .loading-spinner-gallery {
            width: 60px;
            height: 60px;
            border: 4px solid #e9ecef;
            border-top: 4px solid #667eea;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .loading-text-gallery {
            margin-top: 1.5rem;
            font-size: 1.125rem;
            font-weight: 600;
            color: #718096;
          }
        `}</style>
        <div className="loading-gallery">
          <div className="loading-spinner-gallery"></div>
          <p className="loading-text-gallery">Loading Gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-gallery-container">
        <div className="loading-gallery">
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
          <h4 style={{ color: "#e53e3e", fontWeight: "700" }}>
            Error Loading Gallery
          </h4>
          <p style={{ color: "#718096" }}>{error.message}</p>
        </div>
      </div>
    );
  }

  const allImages = Data?.images?.reverse() || [];
  const totalItems = allImages.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const currentPage = Math.min(page, totalPages) || 1;
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedImages = allImages.slice(startIndex, endIndex);

  const canPrev = currentPage > 1;
  const canNext = currentPage < totalPages;

  return (
    <div className="modern-gallery-container">
      <style>{`
        .modern-gallery-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          padding: 2rem;
        }

        .gallery-header {
          background: white;
          padding: 2rem;
          border-radius: 20px;
          margin-bottom: 2rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .gallery-title {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 2rem;
          font-weight: 800;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .gallery-stats {
          display: flex;
          gap: 1.5rem;
          margin-top: 1rem;
        }

        .gallery-stat {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: #f8f9fa;
          border-radius: 12px;
          font-size: 0.9rem;
          font-weight: 600;
          color: #4a5568;
        }

        .gallery-stat-icon {
          font-size: 1.25rem;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .gallery-item {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          background: white;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          animation: fadeInUp 0.5s ease forwards;
          opacity: 0;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .gallery-item:nth-child(1) { animation-delay: 0.05s; }
        .gallery-item:nth-child(2) { animation-delay: 0.1s; }
        .gallery-item:nth-child(3) { animation-delay: 0.15s; }
        .gallery-item:nth-child(4) { animation-delay: 0.2s; }
        .gallery-item:nth-child(5) { animation-delay: 0.25s; }
        .gallery-item:nth-child(6) { animation-delay: 0.3s; }

        .gallery-item:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(102, 126, 234, 0.2);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .gallery-image-wrapper {
          position: relative;
          width: 100%;
          padding-top: 75%;
          overflow: hidden;
          background: #f8f9fa;
        }

        .gallery-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .gallery-item:hover .gallery-image {
          transform: scale(1.08);
        }

        .gallery-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 1.5rem;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .gallery-item:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-actions {
          display: flex;
          gap: 0.75rem;
        }

        .gallery-btn {
          flex: 1;
          padding: 0.75rem;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }

        .gallery-btn-copy {
          background: white;
          color: #2d3748;
        }

        .gallery-btn-copy:hover {
          background: #f7fafc;
          transform: scale(1.05);
        }

        .gallery-btn-delete {
          background: #fc8181;
          color: white;
        }

        .gallery-btn-delete:hover {
          background: #f56565;
          transform: scale(1.05);
        }

        .gallery-btn-delete:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .gallery-index {
          position: absolute;
          top: 1rem;
          left: 1rem;
          width: 36px;
          height: 36px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.85rem;
          color: #2d3748;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          z-index: 2;
        }

        .pagination-wrapper {
          background: white;
          padding: 1.5rem 2rem;
          border-radius: 20px;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1.5rem;
        }

        .pagination-btn {
          padding: 0.75rem 1.75rem;
          border: 2px solid #e9ecef;
          background: white;
          border-radius: 12px;
          font-weight: 600;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .pagination-btn:not(:disabled):hover {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-color: transparent;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .pagination-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        .pagination-info {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-radius: 12px;
          font-weight: 700;
          font-size: 0.95rem;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .empty-gallery {
          text-align: center;
          padding: 4rem 2rem;
          background: white;
          border-radius: 20px;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .empty-gallery-icon {
          font-size: 4rem;
          margin-bottom: 1rem;
        }

        .empty-gallery-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #2d3748;
          margin-bottom: 0.5rem;
        }

        .empty-gallery-text {
          color: #718096;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .modern-gallery-container {
            padding: 1rem;
          }

          .gallery-header {
            padding: 1.5rem;
          }

          .gallery-title {
            font-size: 1.5rem;
          }

          .gallery-grid {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
            gap: 1rem;
          }

          .pagination-wrapper {
            padding: 1rem;
            flex-direction: column;
            gap: 1rem;
          }

          .pagination-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>

      {/* Header */}
      <div className="gallery-header">
        <h1 className="gallery-title">🖼️ Image Gallery</h1>
        <div className="gallery-stats">
          <div className="gallery-stat">
            <span className="gallery-stat-icon">📊</span>
            <span>Total: {totalItems}</span>
          </div>
          <div className="gallery-stat">
            <span className="gallery-stat-icon">📄</span>
            <span>
              Page: {currentPage}/{totalPages}
            </span>
          </div>
          <div className="gallery-stat">
            <span className="gallery-stat-icon">👁️</span>
            <span>Showing: {paginatedImages.length}</span>
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      {paginatedImages.length > 0 ? (
        <>
          <div className="gallery-grid">
            {paginatedImages.map((imgUrl, index) => (
              <div
                className="gallery-item"
                key={startIndex + index}
                // onMouseEnter={() => setHoveredImage(startIndex + index)}
                // onMouseLeave={() => setHoveredImage(null)}
              >
                <div className="gallery-index">{startIndex + index + 1}</div>

                <div className="gallery-image-wrapper">
                  <img
                    src={imgUrl.url}
                    alt={`Gallery ${startIndex + index + 1}`}
                    className="gallery-image"
                    loading="lazy"
                  />

                  <div className="gallery-overlay">
                    <div className="gallery-actions">
                      <button
                        className="gallery-btn gallery-btn-copy"
                        onClick={() => copyToClipboard(imgUrl.url)}
                        type="button"
                      >
                        📋 Copy
                      </button>
                      {/* <button
                        className="gallery-btn gallery-btn-delete"
                        onClick={() => onDelete(imgUrl.url)}
                        disabled={loading}
                        type="button"
                      >
                        🗑️ {loading ? "..." : "Delete"}
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="pagination-wrapper">
            <button
              className="pagination-btn"
              onClick={() => setPage((old) => Math.max(old - 1, 1))}
              disabled={!canPrev}
              type="button"
            >
              ← Previous
            </button>

            <div className="pagination-info">
              Page {currentPage} of {totalPages}
            </div>

            <button
              className="pagination-btn"
              onClick={() => setPage((old) => Math.min(old + 1, totalPages))}
              disabled={!canNext}
              type="button"
            >
              Next →
            </button>
          </div>
        </>
      ) : (
        <div className="empty-gallery">
          <div className="empty-gallery-icon">📭</div>
          <h3 className="empty-gallery-title">No Images Found</h3>
          <p className="empty-gallery-text">
            Upload some images to get started
          </p>
        </div>
      )}
    </div>
  );
}

export default Gallery;
